import React from 'react';

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-medical-50 to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo and header */}
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-medical-600 rounded-lg flex items-center justify-center">
            <svg
              className="h-8 w-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            EMT Ambulans CRM
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Güvenli giriş yapın ve vakalarınızı yönetin
          </p>
        </div>

        {/* Main content */}
        <div className="bg-white py-8 px-6 shadow-lg rounded-lg border border-gray-200">
          {children}
        </div>

        {/* Footer */}
        <footer className="mt-12 text-center text-sm text-gray-600">
          © 2024 EMT Ambulans. Tüm hakları saklıdır.
        </footer>
      </div>
    </div>
  );
} 